import { COLORS } from "../../../../../Diathrive/src/utils/Constants";

const styles = {
  dateInput: {
    border: "1px solid #C3CCD9",
    height: "28px",
    padding: "12px 16px 13px",
    borderRadius: "16px",
    color: COLORS.black,
    fontSize: "16px",
    fontFamily: "Silka-Regular",
    outlineWidth: 0,
    width: "calc(100% - 36px)",
  },
  headerContainer:{
    margin: 10,
    display: "flex",
    justifyContent: "center",
  }
};

export default styles;
